'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n  width: ', 'px;\n  min-height: ', 'px;\n  display: table;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  border-collapse: collapse;\n'], ['\n  width: ', 'px;\n  min-height: ', 'px;\n  display: table;\n  box-sizing: border-box;\n  -moz-box-sizing: border-box;\n  -webkit-box-sizing: border-box;\n  border-collapse: collapse;\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Container = _styledComponents2.default.div(_templateObject, function (props) {
  return props.width;
}, function (props) {
  return props.height;
});

var DivTable = function (_React$Component) {
  _inherits(DivTable, _React$Component);

  function DivTable(props) {
    _classCallCheck(this, DivTable);

    var _this = _possibleConstructorReturn(this, (DivTable.__proto__ || Object.getPrototypeOf(DivTable)).call(this, props));

    _this.validRowChildren = _this.validRowChildren.bind(_this);
    return _this;
  }

  _createClass(DivTable, [{
    key: 'validRowChildren',
    value: function validRowChildren(children) {
      var _props = this.props,
          height = _props.height,
          width = _props.width;
      var rows = [];
      var i = 0;

      if (!children) {
        return;
      }

      var amountChildren = React.Children.toArray(children).length;
      var restHeight = height;
      React.Children.forEach(children, function (child) {
        var childRowHeight = child.props.rowHeight;

        if (childRowHeight) {
          restHeight -= childRowHeight;
          --amountChildren;
        }
      });
      React.Children.forEach(children, function (child) {
        var childRowHeight = child.props.rowHeight;

        if (child === null) {
          return;
        }

        var displayName = React.isValidElement(child) ? child.type.displayName : '';
        (0, _warning2.default)(displayName === 'DivRow', "Inside DivTable component should only have 'DivRow' component as children"); // eslint-disable-line max-len

        rows.push(React.cloneElement(child, {
          width: width,
          height: height,
          key: ++i,
          rowHeight: childRowHeight ? childRowHeight : restHeight / amountChildren
        }));
      });
      return rows;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          outerStyle = _props2.outerStyle,
          style = _props2.style,
          width = _props2.width,
          height = _props2.height,
          children = _props2.children,
          rest = _objectWithoutProperties(_props2, ['outerStyle', 'style', 'width', 'height', 'children']);

      return React.createElement(Container, _extends({
        style: outerStyle,
        width: width,
        height: height
      }, rest), React.createElement('div', {
        style: style
      }, this.validRowChildren(children)));
    }
  }]);

  return DivTable;
}(React.Component);

DivTable.displayName = 'DivTable';
DivTable.defaultProps = {
  style: {},
  width: 350,
  height: 350
};
exports.default = DivTable;